import FraudTrackingDetail from 'components/viewFraudTracking/FraudTrackingDetail.component';

const ViewFraudTrackingDetailPage = ({
	isFraudDetails,
}: {
	isFraudDetails: boolean;
}) => {
	return <FraudTrackingDetail isFraudDetails={isFraudDetails} />;
};

export default ViewFraudTrackingDetailPage;
